module.exports = __webpack_public_path__ + "img/firma_template1.1af7d7f.svg";